__webpack_require__.p = "https://mypurchasesui-prod-endpoint.azureedge.net/_next/";